import { MessageDialog } from '../utils/MessageDialog';
import { ContextDTO } from '../../src_server/entity/dto/ContextDTO';
import { Session } from '../utils/Session';
import { ContextDataService } from './remote/ContextDataService';

export class ContextDataServiceExt extends ContextDataService {
  /**
   * セッションからユーザのコンテキスト情報を取得
   */
  public async getContext() {
    let dto = Session.get<ContextDTO>('CONTEXT');
    // コンプリートしていなければ取り直す
    if (!dto || dto.is_complete === false || dto.is_input_card === false) {
      try {
        const resposne = await this.getContextData(Session.getSessionUserId());
        dto = resposne.data;
        this.saveContext(dto);
      } catch (error) {
        MessageDialog.alert(error);
      }
    }
    return dto;
  }

  public saveContext(dto: ContextDTO) {
    Session.set<ContextDTO>('CONTEXT', dto);
  }
}
